export const GET_GROWPLAN_REQUEST = 'GET_GROWPLAN_REQUEST'
export const GET_GROWPLAN_SUCCESS = 'GET_GROWPLAN_SUCCESS'
export const GET_GROWPLAN_FAILURE = 'GET_GROWPLAN_FAILURE'

export const GET_PLANT_CONTAINER_TYPES_REQUEST = 'GET_PLANT_CONTAINER_TYPES_REQUEST'
export const GET_PLANT_CONTAINER_TYPES_SUCCESS = 'GET_PLANT_CONTAINER_TYPES_SUCCESS'
export const GET_PLANT_CONTAINER_TYPES_FAILURE = 'GET_PLANT_CONTAINER_TYPES_FAILURE'

export const DELETE_GROW_PHASE_REQUEST = 'DELETE_GROW_PHASE_REQUEST'
export const DELETE_GROW_PHASE_SUCCESS = 'DELETE_GROW_PHASE_SUCCESS'
export const DELETE_GROW_PHASE_FAILURE = 'DELETE_GROW_PHASE_FAILURE'

export const DELETE_GROW_TASK_REQUEST = 'DELETE_GROW_TASK_REQUEST'
export const DELETE_GROW_TASK_SUCCESS = 'DELETE_GROW_TASK_SUCCESS'
export const DELETE_GROW_TASK_FAILURE = 'DELETE_GROW_TASK_FAILURE'